"use client"

import React, { useState } from 'react';

const InputText = ({ data, name, error, required, onBlur, onFocus, onKeyDown, darkBGValue, lightBGValue, defaultValue}) => {
  const {
    id,
    value,
    onChange,
    label,
    type: initialType,
    pattern,
    extraClassNames,
    placeholder,
    disabled,

  } = data;

  // Use state to manage input type (password or text)
  const [type, setType] = useState(initialType);

  const toggleVisibility = () => {
    // Toggle between password and text
    setType((prevType) => (prevType === 'password' ? 'text' : 'password'));
  };


  return (
    <>
      <div className="relative">
        <input
        // defaultValue={defaultValue}
          disabled={disabled}
          type={type}
          id={id}
          required={required}
          pattern={pattern}
          value={value || ""}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          name={name}
          className={`${extraClassNames ? extraClassNames : ''} min-h-14 max-h-14  block px-2.5 py-4 w-full text-sm text-gray-900 ${lightBGValue || 'bg-transparent border border-gray-500'} rounded-lg  appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-slate-300 dark:border-slate-600'} dark:focus:border-teal-400 focus:outline-none focus:ring-0 focus:border-teal-400 peer`}
          placeholder={placeholder || ' '}
        />
        <label
          htmlFor={id}
          className={`whitespace-nowrap absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] ${lightBGValue || 'bg-white'} ${darkBGValue ? darkBGValue : 'dark:bg-slate-950'} px-2 peer-focus:px-2 peer-focus:text-teal-400 peer-focus:dark:text-teal-400 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1 rounded`}
        >
          {label}
        </label>
       {data.type === 'password' && <span
          className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-teal-400 cursor-pointer"
          onClick={toggleVisibility}
        >
          {type === 'password' ? <><i className="fa-solid fa-eye"></i></> : <><i className="fa-solid fa-eye-slash"></i></>}
        </span>}
      </div>
    </>
  );
};

export default InputText;




// const InputText = ({data, name, error, required}) => {

//      const id = data.id
//      const value = data.value
//      const onChange = data.onChange
//      const label = data.label
//      let type = data.type
//      const pattern = data.pattern
//      const extraClassNames = data.extraClassNames
//      const placeholder = data.placeholder
//      const disabled = data.disabled
//      const darkBGValue = data.darkBGValue




//      return (
//         <>
//   <div className="relative">
//     <input 
//       disabled={disabled}
//       type={type} 
//       id={id}
//       required={required}
//       pattern={pattern}
//       value={value}
//       onChange={onChange}
//       name={name}
//       className={`${extraClassNames ? extraClassNames : ''} border block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-500 appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-gray-500'} dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
//       placeholder={placeholder || ' '}
//     />
//     <label htmlFor={id} className={`absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white dark:bg-slate-${darkBGValue ? darkBGValue : 900} px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}>
//       {label}
//     </label>
//     <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-blue-600 cursor-pointer" onClick={()=>{type="text"}}>
//       show
//     </span>
//   </div>
// </>
// //      <>
// //       <div className="relative">
// //           <input 
// //                 disabled = {disabled}
// //                type={type} 
// //                id={id}
// //                required={required}
// //                pattern={pattern}
// //                value={value}
// //                onChange={onChange}
// //                name={name}
// //                className={`${extraClassNames ? extraClassNames : ''} border block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-500 appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-gray-500'} dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer`} placeholder={placeholder || ' '}/>
// //     <label htmlFor={id} className={`absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white dark:bg-slate-${darkBGValue ? darkBGValue : 900} px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}>{label}</label> 

// // </div></>
// )
// }

// export default InputText




























//v1 
// "use client"

// import React, { useState } from 'react';


// // Errors are implemented in the following fashion: 
// // error={missingFields === 'company_name' ? true : false}

// const InputText = ({ data, name, error, required, onBlur, onFocus, onKeyDown, lightBGValue }) => {
//   const {
//     id,
//     value,
//     onChange,
//     label,
//     type: initialType,
//     pattern,
//     extraClassNames,
//     placeholder,
//     disabled,
//     darkBGValue,
//   } = data;

//   // Use state to manage input type (password or text)
//   const [type, setType] = useState(initialType);

//   const toggleVisibility = () => {
//     // Toggle between password and text
//     setType((prevType) => (prevType === 'password' ? 'text' : 'password'));
//   };

//   return (
//     <>
//       <div className="relative">
//         <input
//           disabled={disabled}
//           type={type}
//           id={id}
//           required={required}
//           pattern={pattern}
//           value={value || ''}
//           onChange={onChange}
//           onBlur={onBlur}
//           onFocus={onFocus}
//           onKeyDown={onKeyDown}
//           name={name}
//           className={`${extraClassNames ? extraClassNames : ''} border block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-slate-400 dark:border-slate-600'}  dark:focus:border-teal-400 focus:outline-none focus:ring-0 focus:border-teal-400 peer`}
//           placeholder={placeholder || ' '}
//         />
//         <label
//           htmlFor={id}
//           className={`absolute text-sm text-slate-500 dark:text-slate-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] ${lightBGValue ? lightBGValue : 'bg-white'} dark:bg-slate-${darkBGValue ? darkBGValue : 900} px-2 peer-focus:px-2 peer-focus:text-teal-500 peer-focus:dark:text-teal-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}
//         >
//           {label}
//         </label>
//        {data.type === 'password' && <span
//           className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-blue-600 cursor-pointer"
//           onClick={toggleVisibility}
//         >
//           {type === 'password' ? <><i className="fa-solid fa-eye text-teal-500"></i></> : <><i className="fa-solid fa-eye-slash text-teal-500"></i></>}
//         </span>}
//       </div>
//     </>
//   );
// };

// export default InputText;




// // const InputText = ({data, name, error, required}) => {

// //      const id = data.id
// //      const value = data.value
// //      const onChange = data.onChange
// //      const label = data.label
// //      let type = data.type
// //      const pattern = data.pattern
// //      const extraClassNames = data.extraClassNames
// //      const placeholder = data.placeholder
// //      const disabled = data.disabled
// //      const darkBGValue = data.darkBGValue




// //      return (
// //         <>
// //   <div className="relative">
// //     <input 
// //       disabled={disabled}
// //       type={type} 
// //       id={id}
// //       required={required}
// //       pattern={pattern}
// //       value={value}
// //       onChange={onChange}
// //       name={name}
// //       className={`${extraClassNames ? extraClassNames : ''} border block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-500 appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-gray-500'} dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer`}
// //       placeholder={placeholder || ' '}
// //     />
// //     <label htmlFor={id} className={`absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white dark:bg-slate-${darkBGValue ? darkBGValue : 900} px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}>
// //       {label}
// //     </label>
// //     <span className="absolute right-2 top-1/2 transform -translate-y-1/2 text-sm text-blue-600 cursor-pointer" onClick={()=>{type="text"}}>
// //       show
// //     </span>
// //   </div>
// // </>
// // //      <>
// // //       <div className="relative">
// // //           <input 
// // //                 disabled = {disabled}
// // //                type={type} 
// // //                id={id}
// // //                required={required}
// // //                pattern={pattern}
// // //                value={value}
// // //                onChange={onChange}
// // //                name={name}
// // //                className={`${extraClassNames ? extraClassNames : ''} border block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-transparent rounded-lg border border-gray-500 appearance-none dark:text-white ${error ? 'border-red-500 dark:border-red-500' : 'border-gray-500'} dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer`} placeholder={placeholder || ' '}/>
// // //     <label htmlFor={id} className={`absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white dark:bg-slate-${darkBGValue ? darkBGValue : 900} px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1`}>{label}</label> 

// // // </div></>
// // )
// // }

// // export default InputText